import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { CustomerMasterService } from '../../shared/services/customer-master.service';
import { N4sShipmentOption, DEFAULT_TRANSPORT_MODE, DEFAULT_INCOTERM } from '../models/need4steel';

const DEFAULT_SHIPMENT: N4sShipmentOption[] = [{ tmode: DEFAULT_TRANSPORT_MODE, incoterm: DEFAULT_INCOTERM }];

@Injectable({ providedIn: 'root' })
export class N4sShipmentCacheService {
	private shipmentsByShipTo: Map<string, N4sShipmentOption[]> | null = null;

	constructor(private readonly customerMasterService: CustomerMasterService) {}

	isLoaded(): boolean {
		return this.shipmentsByShipTo !== null;
	}

	resetCache(): void {
		this.shipmentsByShipTo = null;
	}

	async loadCache(shipToIds: string[], service: string): Promise<void> {
		if (this.shipmentsByShipTo !== null) {
			return; // already loaded
		}
		try {
			const result = await firstValueFrom(
				this.customerMasterService.getPartnersShipments(shipToIds, service)
			);
			this.shipmentsByShipTo = new Map(Object.entries(result));
		} catch (err: unknown) {
			console.error('N4S ERROR - SHIPMENTS Customer Master - error to get data for', shipToIds, err);
			this.shipmentsByShipTo = new Map(); // mark as loaded (empty = all default)
		}
	}

	getShipmentsForShipTo(shipToId: string): N4sShipmentOption[] {
		if (!this.shipmentsByShipTo) {
			return DEFAULT_SHIPMENT;
		}
		// Try padded (10 chars) and unpadded
		const padded = shipToId.padStart(10, '0');
		return this.shipmentsByShipTo.get(padded)
			?? this.shipmentsByShipTo.get(shipToId)
			?? DEFAULT_SHIPMENT;
	}
}
